/**
 * Em qual aba Metas abre.
 *
 * A padrão é a de reservas. Quem não tem nada nela e tem limite abre nos
 * limites — senão vê uma tela vazia com a própria meta atrás de um clique
 * (pedido dela, em 06/10).
 *
 * "Nada nela" conta as três coisas que a aba de reservas mostra: as reservas,
 * as metas compartilhadas e os CONVITES para uma. Um convite esperando
 * resposta é motivo para ficar: mandado para os limites, ele ficaria onde ela
 * não olha.
 *
 * Sem limite nenhum, fica em reservas: é lá que mora o convite para criar a
 * primeira meta.
 */
export type AbaDeMetas = 'reserve' | 'category_limit';

export const abaInicialDeMetas = (tem: {
  reservas: number; compartilhadas: number; convites: number; limites: number;
}): AbaDeMetas =>
  tem.reservas === 0 && tem.compartilhadas === 0 && tem.convites === 0 && tem.limites > 0
    ? 'category_limit'
    : 'reserve';
